<template>
  <h4 class="alert alert-danger">
    {{ $t("PLEASE_PERFORM_QUALITY_CONTROL") }}
  </h4>
</template>

<script>
export default {};
</script>
